<template>
  <div>
    <div style="position: relative">
      <img
        :src="technology.titlePicture"
        :width="imgwidth + 'px'"
        :height="imgHeight + 'px'"
        class="img_index"
      />
      <div style="color: #e6e6e6">
        <img
          class="img2"
          :src="technology.titlePicture2"
          :width="img2width + 'px'"
        />
        <img
          class="img3"
          :src="technology.titlePicture3"
          :width="img3width + 'px'"
        />
        <img
          class="img1"
          :src="technology.titlePicture1"
          :width="img1width + 'px'"
        />
        <div class="title">
          <h2>{{ technology.title }}</h2>
          <span>{{ technology.titleContent }}</span>
        </div>
        <h1 style="position: absolute; top: 78%; left: 47%; font-size: 2.5em">
          {{ technology.mainTitle }}
        </h1>
      </div>
    </div>

    <div style="padding-top: 30px">
      <el-row style="max-width: 1200px; margin: 50px auto 20px">
        <el-col
          :span="8"
          v-for="(item, index) in technology.technologyList"
          :key="index"
          style="display: flex; flex-direction: column; align-items: center"
        >
          <el-image :src="item.picture" style="width: 300px; height: 330px" />
          <span style="font-size: 14px; margin: 10px">{{ item.content }}</span>
          <span style="font-weight: bold; margin-bottom: 30px">{{
            item.title
          }}</span>
        </el-col>
      </el-row>
    </div>

    <div>
      <el-image
        :src="technology.posBackground"
        style="width: 100%; height: 450px; z-index: -1"
      />
      <h2 style="color: #505050; margin-top: -200px">
        {{ technology.posTitle }}
      </h2>
      <el-image
        :src="technology.posPicture"
        style="width: 800px; height: 300px"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Technology",
  data() {
    return {
      technology: global.technology,
      imgHeight: 525,
      imgwidth: 0,
      img1width: 300,
      img2with: 600,
      img3width: 250,
    };
  },
  created() {
    // 监听窗口大小变化事件
    window.addEventListener("resize", this.handleResize);
    this.imgwidth = window.innerWidth;
    this.handleResize();
  },
  destroyed() {
    // 移除窗口大小变化事件监听器
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.imgwidth = window.innerWidth;
  },
  methods: {
    // 窗口大小变化时更新页面宽度值
    handleResize() {
      this.imgHeight = window.innerWidth / 3;
      this.imgwidth = window.innerWidth;
      this.img1width = (window.innerWidth * 300) / 1890;
      this.img2width = (window.innerWidth * 600) / 1890;
      this.img3width = (window.innerWidth * 250) / 1890;
    },
  },
};
</script>

<style scoped>
.img_index {
  position: relative;
  display: inline-block;
}
.title {
  position: absolute;
  top: 2%;
  left: 15%;
  width: 400px;
  text-align: left;
}
.img1 {
  position: absolute;
  top: 62%;
  left: 24%;
}
.img2 {
  position: absolute;
  top: 22%;
  left: 38%;
}
.img3 {
  position: absolute;
  top: 5%;
  left: 66%;
}
</style>



// WEBPACK FOOTER //
// src/views/technology/technology.vue